class HeaderSearch extends HTMLElement {
  constructor() {
    super();

    this.searchButton = this.querySelector("[data-search-button]");
    this.searchForm = this.querySelector(".header__search");
    this.searchFormClose = this.querySelector("[data-search-form-close]");
    this.header = this.closest(".header");
    this.promoBar = document.querySelector(".promo-banner");

    this.searchButton.addEventListener("click", () => {
      if (this.searchForm.classList.contains("active")) {
        this.closeSearchForm();
      } else {
        this.openSearchForm();
      }
    });

    this.searchFormClose?.addEventListener("click", () => {
      this.closeSearchForm();
    });

    window.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.closeSearchForm();
      }
    });

    window.addEventListener("resize", () => {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        this.closeSearchForm();
      }
    });

    this._open = () => this.openSearchForm();

    document.addEventListener("header-search:open", this._open);

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.searchForm.classList.contains("active")) {
        this.closeSearchForm();
      }
    };

    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("header-search:open", this._open);
  }

  openSearchForm() {
    if (this.searchForm.classList.contains("active")) return;

    const barHeight = this.promoBar?.getBoundingClientRect().height || 0;
    const headerHeight = this.header.getBoundingClientRect().height;

    this.searchForm.style.setProperty(
      "--search-form-max-height",
      `calc(100vh - ${barHeight}px - ${headerHeight}px)`,
    );

    this.searchForm.style.display = "block";
    window.openDimmer(this);
    this.header && this.header.classList.add("search-is-opened");

    window.requestAnimationFrame(() => {
      this.searchForm.classList.add("active");
      window.trapFocus(
        this.searchForm,
        this.searchForm.querySelector('input[name="q"]'),
      );
    });
  }

  closeSearchForm() {
    if (!this.searchForm.classList.contains("active")) return;

    const onTransitionEnd = () => {
      this.searchForm.style.display = "none";
      this.searchForm.removeEventListener("transitionend", onTransitionEnd);
      this.querySelector("live-search-wrapper")?.dispatchEvent(
        new CustomEvent("live-search-wrapper:clear"),
      );
      window.removeTrapFocus(this.searchButton);
    };

    this.searchForm.addEventListener("transitionend", onTransitionEnd);

    this.searchForm.classList.remove("active");
    window.closeDimmer(this);
    this.header && this.header.classList.remove("search-is-opened");
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
